const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

function convertLessThanOneThousand(number) {
  if (number === 0) {
    return '';
  }

  let words = '';

  if (number >= 100) {
    words += ones[Math.floor(number / 100)] + ' hundred ';
    number %= 100;
  }

  if (number >= 20) {
    words += tens[Math.floor(number / 10)] + ' ';
    number %= 10;
  } else if (number >= 10) {
    words += teens[number - 10] + ' ';
    return words.trim();
  }

  if (number > 0) {
    words += ones[number] + ' ';
  }

  return words.trim();
}

export function numberToWords(number) {
  if (number === 0) {
    return 'zero';
  }

  let words = '';
  
  if (number < 0) {
    words += 'negative ';
    number = Math.abs(number);
  }

  if (number >= 1000000000) {
    words += convertLessThanOneThousand(Math.floor(number / 1000000000)) + ' billion ';
    number %= 1000000000;
  }

  if (number >= 1000000) {
    words += convertLessThanOneThousand(Math.floor(number / 1000000)) + ' million ';
    number %= 1000000;
  }

  if (number >= 1000) {
    words += convertLessThanOneThousand(Math.floor(number / 1000)) + ' thousand ';
    number %= 1000;
  }

  words += convertLessThanOneThousand(number);

  return words.trim();
}